module.exports = __webpack_public_path__ + "static/media/elaina1.645ac3fb.jpg";